import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import React from 'react';
import Notifications from '../../../Notifications';
import { NotificationType } from '../../types';
import LabelAsNotification from './LabelAsNotification';
const NotificationsForMM = ()=>{
    return /*#__PURE__*/ React.createElement(Notifications, {
        onlyUseRenderFunction: true
    }, (notification)=>{
        switch(notification.type){
            case NotificationType.LABEL_AS:
                return /*#__PURE__*/ React.createElement(LabelAsNotification, _object_spread({
                    id: notification.id,
                    queueName: notification.queueName
                }, notification.params));
            default:
                return null;
        }
    });
};
NotificationsForMM.displayName = 'NotificationsForMM';
export default NotificationsForMM;

//# sourceMappingURL=NotificationsForMM.js.map